import {Switch} from "@mui/material";
import {kPreviewSwitchStyle} from "../../../constants/styles";

export default function PreviewCorrectionSwitcher({displayCorrection, toggleView}) {
    // Used in PreviewQuestionSideBar to display switch
    // between question and its correction

    // BUILD
    return (
        <div className={"mt-[8px] w-full flex justify-center items-center space-x-[2px] font-medium"}>
            <span className={`${displayCorrection ? "text-greyLight7" : "text-greyLight11 font-semibold"}`}>
                Flash
            </span>
            <Switch value={displayCorrection}
                    onChange={() => toggleView()}
                    sx={kPreviewSwitchStyle} />
            <span className={`${displayCorrection ? "text-greyLight11 font-semibold" : "text-greyLight7"}`}>
                Correction
            </span>
        </div>
    );
}